export default {
  api: {
    graphql: process.env.NODE_ENV === 'production' ? 'https://graphql.app.snootik.com/graphql' : 'https://graphql.app.snootik.com/graphql',
    websocket: 'ws://api.snootik.com'
  },
  locale: {
    list: [
      {
        name: 'Slovak',
        slug: 'sk'
      },
      {
        name: 'English',
        slug: 'en'
      }
    ],
    fallback: 'en'
  },
  debug: process.env.NODE_ENV === 'development'
}



// WEBPACK FOOTER //
// ./src/config/index.js